import { Controller } from "@hotwired/stimulus"

/**
 * Controller for the agent search page in the PWA.
 * Handles displaying agent contact details in a modal when an agent is selected.
 * 
 * @extends Controller
 */
export default class extends Controller {
  static targets = ["modal", "name", "office", "phone", "emailText", "callLink", "emailLink", "image", "imageContainer"]

  /**
   * Selects an agent from the search results and opens the modal.
   * @param {Event} event - The click event
   */
  selectAgent(event) {
    const agentElement = event.currentTarget
    
    this.populateModal({
      name: agentElement.dataset.agentName,
      phone: agentElement.dataset.agentPhone,
      email: agentElement.dataset.agentEmail,
      image: agentElement.dataset.agentImage,
      office: agentElement.dataset.agentOffice
    })
    
    this.modalTarget.showModal()
  }

  /**
   * Populates modal content with provided data.
   * Handles showing/hiding elements based on data availability.
   * 
   * @private
   * @param {Object} data - The data to populate
   * @param {string} data.name - The name to display
   * @param {string} data.phone - The phone number
   * @param {string} data.email - The email address
   * @param {string} data.image - The image source URL
   * @param {string} data.office - The office title
   */
  populateModal({ name, phone, email, image, office }) {
    this.nameTarget.textContent = name
    this.officeTarget.textContent = office || ""
    
    // Show/hide image based on availability
    if (image && image.trim()) {
      this.imageTarget.src = image
      this.imageTarget.alt = name
      this.imageContainerTarget.style.display = "block"
    } else {
      this.imageContainerTarget.style.display = "none"
    }
    
    // Show/hide phone link based on availability
    if (phone && phone.trim()) {
      this.phoneTarget.textContent = phone
      this.callLinkTarget.href = `tel:${phone.replace(/\D/g, "")}`
      this.callLinkTarget.style.display = "block"
    } else {
      this.callLinkTarget.style.display = "none"
    }
    
    // Show/hide email link based on availability
    if (email && email.trim()) {
      this.emailTextTarget.textContent = email
      this.emailLinkTarget.href = `mailto:${email}`
      this.emailLinkTarget.style.display = "block"
    } else {
      this.emailLinkTarget.style.display = "none"
    }
  }
}
